import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import useMarketingUrl from '@/utils/urls/useMarketingUrl';

import { SECURITY } from '@/lib/routes/privateRoutes';

// Components
import H3 from '@/components/base/Headings/H3';
import LinkBase from '@/components/base/LinkBase';
// Layout
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import SecurityForm from '@/components/pages/settings/SecurityForm';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';

// Endpoints

const marketingLinks = [
    { label: 'terms_of_use', url: 'terms_of_use' },
    { label: 'terms_of_subscription', url: 'terms_of_subscription' },
    { label: 'privacy_policy', url: 'privacy_policy' },
    { label: 'gdpr', url: 'gdpr' },
    { label: 'report_a_problem', url: 'contact' },
    {
        label: 'request_about_private_data',
        url: 'request_about_private_data'
    }
] as const;

function SideContent() {
    const { t: tSettings } = useTranslation('settings');
    const { t: tCommons } = useTranslation('commons');
    const { marketingUrl } = useMarketingUrl();

    return (
        <div className="p-8 xl:px-7 xl:py-10">
            <H3 className="mb-m">{tSettings('security_page.additional_column.title')}</H3>
            <p className="mb-3 font-GSemiBold text-xs leading-4 text-icoGray-500 dark:text-icoDarkMode-wolf">
                {tSettings('security_page.additional_column.text')}
            </p>
            <ul className="space-y-3">
                {marketingLinks.map((link) => (
                    <li key={link.label}>
                        <LinkBase
                            href={marketingUrl(link.url)}
                            className="text-xs text-icoBlue underline"
                            target="_blank"
                            rel="noopener noreferrer">
                            {tCommons(`pages.${link.label}`)}
                        </LinkBase>
                    </li>
                ))}
            </ul>
        </div>
    );
}

function PageContent() {
    return (
        <SettingsWrapper>
            <SettingsWrapper.MainContent>
                <SecurityForm />
            </SettingsWrapper.MainContent>
            <SettingsWrapper.SideContent>
                <SideContent />
            </SettingsWrapper.SideContent>
        </SettingsWrapper>
    );
}

export const getServerSideProps = TranslationService.getTranslationMessagesFromRoute(SECURITY);

export default function Security() {
    return (
        <WrapperSwitchLayout noPadding={true} disableMainScroll={true}>
            <PageContent />
        </WrapperSwitchLayout>
    );
}
